<template>
  <div class="player-quiz-list-page">
    <div class="list-wrap">
      <van-loading v-if="loading" class="loading-center" size="24px" vertical>加载中...</van-loading>
      <van-empty v-else-if="!list.length" description="暂无问卷" />
      <div v-else class="list-inner">
        <div
          v-for="(item, index) in list"
          :key="quizKey(item, index)"
          class="quiz-item"
          @click="onItemClick(item)"
        >
          <div class="item-icon">
            <van-icon name="records" />
          </div>
          <div class="item-main">
            <div class="item-title-row">
              <span class="item-title">{{ item.title || '-' }}</span>
              <span v-if="isRequired(item)" class="item-badge">必填</span>
            </div>
          </div>
          <div
            class="item-status"
            :class="{ done: quizDone(item) }"
          >{{ quizDone(item) ? '已完成' : '未完成' }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { Icon, Loading, Empty, Toast } from 'vant'
import { getBMMatchTeamPlayerQuestions } from '@/api/match'

Vue.use(Icon).use(Loading).use(Empty).use(Toast)

export default {
  name: 'PlayerQuizList',
  data() {
    return {
      loading: true,
      list: [],
      matchId: '',
      teamId: '',
      playerId: '',
      unionMatchId: ''
    }
  },
  mounted() {
    const q = this.$route.query || {}
    this.matchId = q.matchId || ''
    this.teamId = q.teamId || ''
    this.playerId = q.playerId || ''
    this.unionMatchId = q.unionMatchId || ''
    this.fetchList()
  },
  methods: {
    quizKey(item, index) {
      return item.id != null ? item.id : index
    },
    quizDone(item) {
      if (!item) return false
      return Number(item.completed) === 1
    },
    /** 是否报名必须完成（字段名以后端为准，兼容多种命名） */
    isRequired(item) {
      if (!item) return false
      if (Number(item.submitRequired) === 1) return true
      if (Number(item.requiredForSubmit) === 1) return true
      if (Number(item.isRequired) === 1) return true
      return false
    },
    fetchList() {
      if (!this.matchId || !this.teamId || !this.playerId) {
        this.loading = false
        Toast.fail('缺少赛事、球队或队员参数')
        return
      }
      this.loading = true
      getBMMatchTeamPlayerQuestions({
        matchId: this.matchId,
        teamId: this.teamId,
        playerId: this.playerId
      })
        .then((res) => {
          if (!res) {
            this.list = []
            return
          }
          const raw = res.data != null ? res.data : res
          if (Array.isArray(raw.list)) {
            this.list = raw.list
          } else if (Array.isArray(raw)) {
            this.list = raw
          } else {
            this.list = []
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    onItemClick(item) {
      const quizId = item && item.id
      if (quizId == null || quizId === '') {
        Toast('问卷信息不完整')
        return
      }
      this.$router.push({
        path: '/quiz/play',
        query: {
          quizId: String(quizId),
          objType: 'player',
          objId: String(this.playerId)
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.player-quiz-list-page {
  min-height: 100vh;
  background: #f5f6f7;
  box-sizing: border-box;
  padding-bottom: 24px;
}

.page-hd {
  padding: 14px 14px 8px;
  background: #fff;
  border-bottom: 1px solid #eee;
}

.page-title {
  font-size: 17px;
  font-weight: 600;
  color: #303133;
}

.list-wrap {
  padding: 12px 14px 0;
}

.loading-center {
  padding: 48px 0;
  display: flex;
  justify-content: center;
}

.list-inner {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.quiz-item {
  display: flex;
  align-items: center;
  background: #fff;
  border-radius: 10px;
  padding: 0 12px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);
  min-height: 55px;
  box-sizing: border-box;
}

.item-icon {
  flex-shrink: 0;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: linear-gradient(135deg, #67c23a 0%, #529b2e 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 18px;
}

.item-main {
  flex: 1;
  min-width: 0;
  margin-left: 12px;
}

.item-title-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
}

.item-title {
  font-size: 15px;
  font-weight: 500;
  color: #303133;
  line-height: 1.4;
  word-break: break-all;
}

.item-badge {
  font-size: 11px;
  color: #f56c6c;
  border: 1px solid #f56c6c;
  border-radius: 4px;
  padding: 0 4px;
  line-height: 1.4;
}

.item-status {
  flex-shrink: 0;
  font-size: 14px;
  color: #909399;
  margin-left: 8px;

  &.done {
    color: #07c160;
  }
}
</style>
